import { Box, HStack, Stack, Text } from '@chakra-ui/react'
import { IconType } from 'react-icons'
import { StudyHoursInput } from './StudyHoursInput'

type StudyHoursCardProps = {
  accentColor: string
  description: string
  icon: IconType
  label: string
  note: string
  value: string
  onChange: (value: string) => void
}

export const StudyHoursCard = ({
  accentColor,
  description,
  icon: Icon,
  label,
  note,
  value,
  onChange,
}: StudyHoursCardProps) => {
  return (
    <Stack
      border="1px solid"
      borderColor={`${accentColor}.200`}
      borderRadius="xl"
      p={{ base: 5, md: 8 }}
      spacing={6}
    >
      <HStack align="start" minH={{ lg: '124px' }} spacing={5}>
        <Box
          aria-hidden
          bg={`${accentColor}.100`}
          borderRadius="xl"
          color={`${accentColor}.600`}
          p={4}
        >
          <Icon size={36} />
        </Box>
        <Stack spacing={2}>
          <Text fontSize="lg" fontWeight="bold">
            {label}
          </Text>
          <Text color="gray.700">
            {description}
          </Text>
        </Stack>
      </HStack>

      <StudyHoursInput
        accentColor={accentColor}
        label={label}
        value={value}
        onChange={onChange}
      />

      <HStack color={`${accentColor}.600`} spacing={3}>
        <Icon aria-hidden size={24} />
        <Text color="gray.600">{note}</Text>
      </HStack>
    </Stack>
  )
}
